import React, { useContext } from 'react';
import { Image, List, Button, Tabs } from 'antd-mobile';
import styled from 'styled-components';
import { logout } from '../api';
import UserSelfContext from '../utils/self-context';
import WorkEntries from './WorkEntries';
import { featureEnabled, matchesPermission } from '../utils/permission-helpers';

const ProfileDefails = styled(List)`
	padding: 12px;
	border-top: none;
	background: #fff;
	.adm-list-body {
		border-top: none;
		border-bottom: none;
	}
`;

const ProfileWrapper = styled.div`
	width: 100%;
	height: 100%;
	display: flex;
	flex-flow: column;
`;

const Logout = styled(Button)`
	padding:0px;
`;

const TabBar = styled(Tabs)`
	display: flex;
	flex-direction: column;
	height: 100%;
	.adm-tabs-header {
		background: #fff;
	}

	.adm-tabs-content {
		flex: 1;
		overflow:  auto;
		padding: 0px;
	}
`;

const ContentWrapper = styled.div`
	flex: 1;
	min-height: 0;
	overflow:  auto;
	width: 100%;
	background: #f0f2f5;
`;


function Profile() {
	const { userSelf } = useContext(UserSelfContext);

	async function log() {
		await logout();
		window.location.href = `${process.env.API_URL}/login?redirect=${process.env.APP_URL}`;
	}

	return (<ProfileWrapper>
		<ProfileDefails>
			<List.Item
				prefix={
					<Image
						src={`${process.env.API_URL}${userSelf.img}`}
						style={{ borderRadius: 30 }}
						fit='cover'
						width={60}
						height={60}
					/>
				}
				description={userSelf.email}
			>
				{userSelf.name}{userSelf.role_title ? `(${userSelf.role_title})` : ''}
			</List.Item>
		</ProfileDefails>
		<ContentWrapper>
			<TabBar defaultActiveKey="settings">
				{
					(featureEnabled(userSelf, 'work_entries_enabled') &&
					matchesPermission(userSelf, 'view_work_entries')) ?
						<Tabs.Tab
							title="Work Log"
							key='log'
						>
							<WorkEntries />
						</Tabs.Tab> : null
				}
				<Tabs.Tab
					title="Settings"
					key='settings'
				>
					<List header="Active organization">
						<List.Item>
							{userSelf.active_organization.name}
						</List.Item>
					</List>
					<List header=" ">
						<List.Item>
							<Logout onClick={log} color='danger' block fill='none'>Log out</Logout>
						</List.Item>
					</List>
				</Tabs.Tab>
			</TabBar>
		</ContentWrapper>
	</ProfileWrapper>);
}

export default Profile;
